import AssignmentRosterDetailModal from "@app/components/modals/assignments/roster/assignment-roster-detail-modal.tsx";
import AssignmentRosterModal from "@app/components/modals/assignments/roster/assignment-roster-modal.tsx";
import { ActiveEnums, RostersModel } from "@app/data/engine.ts";
import useAssignmentData from "@app/data-hooks/use-assignment-data.ts";
import useRosterData from "@app/data-hooks/use-roster-data.ts";
import { assignmentRosterEntryTableDefinition } from "@app/table-definitions/assignment-roster-entry.table-definition.tsx";
import { AssignmentRosterTableDefinition } from "@app/table-definitions/assignment-roster.table-definition.tsx";
import { Button, Stack } from "@mui/material";
import { DataTable } from "bi-lib";
import { useState } from "react";

interface Props {
    id: number;
}

export default function AssignmentRosterForm({ id }: Props) {
    const [selectedRoster, setViewRoster] = useState<RostersModel>();
    const [rosterOpen, setRosterOpen] = useState(false);
    const [viewEntryDetailId, setViewEntryDetailId] = useState<number>();
    const [editEntryDetailId, setEditEntryDetailId] = useState<number>();
    const [rosterDetailOpen, setRosterDetailOpen] = useState(false);

    const { rosterList, rosterDetailList } = useAssignmentData({
        id,
        rosterId: selectedRoster?.rosterId,
        activeState: ActiveEnums.All,
    });
    const { updateRosterStaffActivation, updateRosterStaffSortBy, deleteRosterDetail } = useRosterData();

    return (
        <>
            <AssignmentRosterModal
                open={rosterOpen}
                onClose={() => {
                    setRosterOpen(false);
                    setEditEntryDetailId(undefined);
                }}
                assignmentId={id}
                rosterId={editEntryDetailId}
            />
            <AssignmentRosterDetailModal
                rosterId={selectedRoster?.rosterId}
                rosterDetailId={viewEntryDetailId}
                open={rosterDetailOpen}
                onClose={() => {
                    setRosterDetailOpen(false);
                    setViewEntryDetailId(undefined);
                }}
            />
            <Stack spacing={5}>
                <DataTable
                    rowsPerPageOptions={[5000]}
                    label={"Roster"}
                    actions={
                        <Button variant={"contained"} onClick={() => setRosterOpen(true)}>
                            Add New
                        </Button>
                    }
                    columns={AssignmentRosterTableDefinition({
                        onEdit: (id) => {
                            setRosterOpen(true);
                            setEditEntryDetailId(id);
                        },
                        onView: (id) => setViewRoster(id),
                        onUpdateSortBy: (id, sortBy) => updateRosterStaffSortBy.mutate({ rosterId: id, sortBy }),
                        onActivateDeactivate: (id, isActive) =>
                            updateRosterStaffActivation.mutate({
                                rosterId: id,
                                isActive,
                            }),
                        minSort: 1,
                        maxSort: rosterList.data?.length ?? 1,
                        rowCount: rosterList.data?.length ?? 0,
                    })}
                    data={rosterList.data ?? []}
                    initialSorting={[{ id: "sortBy", desc: false }]}
                    queryHook={rosterList}
                    initialColumnVisibility={{ sortBy: false }}
                />
                {selectedRoster != undefined && (
                    <DataTable
                        rowsPerPageOptions={[5000]}
                        label={`${selectedRoster.displayName} Roster Details`}
                        actions={
                            <Button variant={"contained"} onClick={() => setRosterDetailOpen(true)}>
                                Add Entry
                            </Button>
                        }
                        columns={assignmentRosterEntryTableDefinition({
                            onEdit: (id) => {
                                setViewEntryDetailId(id);
                                setRosterDetailOpen(true);
                            },
                            onDelete: (id) => deleteRosterDetail.mutate(id!),
                            rowCount: rosterDetailList.data?.length ?? 0,
                        })}
                        data={rosterDetailList.data ?? []}
                        queryHook={rosterDetailList}
                    />
                )}
            </Stack>
        </>
    );
}
